import {getData, postData} from './redux_data';
import {
    GET_TIPO_ZONA_IVA, 
    UPDATE_TIPO_ZONA_IVA,
    ADD_TIPO_ZONA_IVA, 
    MODIFY_TIPO_ZONA_IVA,
    DELETE_TIPO_ZONA_IVA
} from '../constants/action_types';

export function getTipoZonaIva() {
    return getData('CvTipoZonaIvas', GET_TIPO_ZONA_IVA);
}

export function modifyTipoZonaIva(tipoZonaIva) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_ZONA_IVA, payload: tipoZonaIva });
    }
}

export function addTipoZonaIva(tipoZonaIva) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_ZONA_IVA, payload: tipoZonaIva });
    }
}

export function removeTipoZonaIva(tipoZonaIva) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_ZONA_IVA, payload: tipoZonaIva });
    }
}

export function updateTipoZonaIvaDB (tipoZonaIva) {

    return postData('CvTipoZonaIvas/tiposzona', UPDATE_TIPO_ZONA_IVA, tipoZonaIva, 'Tipos de zonas de IVA actualizados', undefined);

}
